// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"9":"8de75d832bcfbc148bb4","42":"25c625140e1884d29d10","702":"83e63b16c6c1c616ff02","715":"1a8aad403544d65882ef"}[chunkId] + ".css";
};